var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Inject } from "@angular/core";
import { CheckUtils, EncryptStorage } from "../..";
import { StorageData } from "../../storage/storage-data";
import { Events } from "ionic-angular";
import { Model } from "../model";
import { StorageType } from "../../storage/storage-type";
var PagesModel = /** @class */ (function (_super) {
    __extends(PagesModel, _super);
    function PagesModel(storage, events) {
        var _this = _super.call(this, storage, events, "pages") || this;
        _this._isLoaded = false;
        _this._pageKey = "page";
        _this._contextKey = "page-context";
        _this.event.PAGE_LOADED = _this._pageKey + ":loaded";
        _this.event.PAGE_CHANGED = _this._pageKey + ":changed";
        _this.event.CONTEXT_CHANGED = _this._contextKey + ":changed";
        return _this;
    }
    PagesModel.prototype.load = function (value) {
        var _this = this;
        if (CheckUtils.isEmpty(value))
            return;
        this._pageKey = "page-" + value;
        this.storage.load(this._pageKey, false, StorageType.SESSION).then(function (res) {
            _this._isLoaded = true;
            if (res != null && typeof res != 'string') {
                _this._page = res;
                _this.events.publish(_this.event.PAGE_LOADED, res);
            }
        });
    };
    Object.defineProperty(PagesModel.prototype, "isLoaded", {
        get: function () {
            return this._isLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagesModel.prototype, "event", {
        get: function () {
            return this._event;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PagesModel.prototype, "context", {
        get: function () {
            return this._context;
        },
        enumerable: true,
        configurable: true
    });
    PagesModel.prototype.setContext = function (value, preventDefault) {
        this._context = value;
        var storageData = new StorageData(this.event.CONTEXT_CHANGED, preventDefault, value);
        storageData.key = this._contextKey;
        storageData.item = value;
        storageData.encrypt = false;
        return this.storage.saveAs(storageData);
    };
    Object.defineProperty(PagesModel.prototype, "page", {
        get: function () {
            return this._page;
        },
        enumerable: true,
        configurable: true
    });
    PagesModel.prototype.setPage = function (value, preventDefault) {
        this._page = value;
        var storageData = new StorageData(this.event.PAGE_CHANGED, preventDefault, value, false, StorageType.SESSION);
        storageData.key = this._pageKey;
        storageData.item = value;
        return this.storage.saveAs(storageData);
    };
    /** @nocollapse */
    PagesModel.ctorParameters = function () { return [
        { type: EncryptStorage, decorators: [{ type: Inject, args: [EncryptStorage,] },] },
        { type: Events, decorators: [{ type: Inject, args: [Events,] },] },
    ]; };
    return PagesModel;
}(Model));
export { PagesModel };
//# sourceMappingURL=pages-model.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/models/page/pages-model.js
// module id = 366
// module chunks = 14